import { OptionType } from '@components/select/dist/types';
import { makeAutoObservable } from 'mobx';

import { buildVatRateSelectOptions } from 'constants/vatRates';
import { RootStore } from 'store/RootStore';
import { MultiSelectChangeData } from 'types/@components/common';

class VatRatesDisplay {
  root: RootStore;
  selectedOptions: OptionType[] = [];

  constructor(root: RootStore) {
    this.root = root;
    makeAutoObservable(this);
    this.resetToAllRates();
  }

  get allOptions(): OptionType[] {
    return buildVatRateSelectOptions(this.root.app.i18n);
  }

  get selectedVatPercentsForDisplay(): number[] | null {
    const total = this.allOptions.length;
    if (this.selectedOptions.length === 0 || this.selectedOptions.length === total) return null;

    return this.selectedOptions.map(o => o.value as number);
  }

  resetToAllRates = () => {
    this.selectedOptions = [...this.allOptions];
  };

  selectOption = (_option: OptionType | null, data: MultiSelectChangeData) => {
    this.selectedOptions = data.array;
  };
}

export { VatRatesDisplay };
